<!--倒计时-->
<template>
    <div>
        <span>{{countMinute}}</span>分<span>{{countSecond}}</span>秒
    </div>
</template>
<script>
    export default {
        name:'homeCounter',
        props:['countdownTime'],
        data:function () {
          return {
            countHour:'00',
            countMinute:'00',
            countSecond:'00',
            setIntTimer:0,
          };
        },
        mounted:function () {
          let self = this;
          let countEndTime = parseInt(this.countdownTime);
          this.showTime(countEndTime,self);
        },
        watch:{
          countdownTime(val){
            let self = this;
            clearInterval(self.setIntTimer);
            let countEndTime = parseInt(val);
            this.showTime(countEndTime,self);
          },
        },
        methods:{
          showTime(counterTime,e){    
            e.setIntTimer = setInterval(function () {
              counterTime=counterTime-0.5;
              if(counterTime<=0){
                counterTime =0;
                clearInterval(e.setIntTimer);
              }
              let hour = parseInt(counterTime/3600);
              let min = parseInt((counterTime - hour * 3600)/60);          
              let sec =  parseInt(counterTime - hour * 3600 -  min * 60);
              e.countHour = hour<10?('0'+hour):hour;
              e.countMinute = min<10?('0'+min):min;             
              e.countSecond = sec<10?('0'+sec):sec; 
            },500);
          }
        },
        computed:{
          formatTime(time){
            let countTime = {hour:0,min:0,sec:0};
            countTime.hour = parseInt(time/1000/3600);
            countTime.min = parseInt((time/1000 - hour * 3600)/60);
            countTime.sec = parseInt(time/1000 - hour * 3600 - min * 60);
            return countTime;
          },

        },
        destroyed:function () {
            clearInterval(this.setIntTimer);
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/CountDown.vue